import './Footer.css';
function Footer()
{
    return(
        <div className="footer">
            {/* <p className="loveNote">Made With <span>❤️❤️❤️</span></p> */}
        </div>
    )
}

export default Footer;